class CollectionLinks {
  constructor() {
    this.container = document.querySelector('[data-collection-links-container]');
    this.toggleButton = document.querySelector('[data-collection-links-toggle]');
    this.viewMoreText = this.toggleButton?.querySelector('.collection-links__view-more-text');
    this.isExpanded = false;

    if (this.toggleButton && this.container) {
      this.init();
    }
  }

  init() {
    // Only initialize on mobile screens (max-width: 768px)
    if (window.innerWidth <= 768) {
      this.toggleButton.addEventListener('click', this.handleToggle.bind(this));
      this.toggleButton.style.display = 'block';
    } else {
      this.toggleButton.style.display = 'none';
    }

    // Handle window resize
    window.addEventListener('resize', this.handleResize.bind(this));
  }

  handleToggle() {
    this.isExpanded = !this.isExpanded;
    
    if (this.isExpanded) {
      this.container.classList.add('collection-links__item--expanded');
      if (this.viewMoreText) {
        this.viewMoreText.textContent = 'View less';
      }
    } else {
      this.container.classList.remove('collection-links__item--expanded');
      if (this.viewMoreText) {
        this.viewMoreText.textContent = 'View more';
      }
    }
  }

  handleResize() {
    if (window.innerWidth <= 768) {
      this.toggleButton.style.display = 'block';
    } else {
      this.toggleButton.style.display = 'none';
      // Reset expanded state on desktop
      this.isExpanded = false;
      this.container.classList.remove('collection-links__item--expanded');
      if (this.viewMoreText) {
        this.viewMoreText.textContent = 'View more';
      }
    }
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new CollectionLinks();
  });
} else {
  new CollectionLinks();
}
